import React, { useEffect, useState } from "react";
import Pagination from "../../Component/Common/Pagination";
import Table from "../../Component/Common/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { warning } from "../../util/Alert";
import UserImage from "../../assets/images/no-profile.jpg";
import {
  getUser,
  isActiveUser,
  deleteUser,
} from "../../store/user/user.action";
import $, { get } from "jquery";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import { covertURl } from "../../util/AwsFunction";
import DataActions from "../../Component/Common/DataActions";
import dayjs from "dayjs";

function ManageUser(props) {
  const { startDate, endDate } = props;
  const dispatch = useDispatch();
  const { user, totalUser } = useSelector((state) => state.user);

  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const [data, setData] = useState();
  const [showURLs, setShowURLs] = useState([]);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");
  const [actionPagination, setActionPagination] = useState("");

  useEffect(() => {
    setData(user);
  }, [user]);

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", UserImage);
    });
  });
  useEffect(() => {
    fetchData();
  }, [data]);

  const fetchData = async () => {
    if (!data || data?.length === 0) {
      return;
    }

    const urls = await Promise.all(
      data?.map(async (item) => {
        const fileNameWithExtension = item?.image?.split("/").pop();
        const { imageURL } = await covertURl(
          "userImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowURLs(urls);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleSelectCheckData = (e, row) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id),
      );
    }
  };
  const handleSelectAll = (event) => {
    const checked = event.target.checked;

    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    const isActiveData = user.filter((user) => {
      return (
        user.isBlock === false &&
        selectCheckData.some((ele) => ele._id === user._id)
      );
    });
    const deActiveData = user.filter((user) => {
      return (
        user.isBlock === true &&
        selectCheckData.some((ele) => ele._id === user._id)
      );
    });

    const getId = isActiveData?.map((item) => item?._id);
    const getId_ = deActiveData?.map((item) => item?._id);
    if (actionPagination === "block") {
      const data = true;
      props.isActiveUser(getId, "user", data);
    } else if (actionPagination === "unblock") {
      const data = false;
      props.isActiveUser(getId_, "user", data);
    } else if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res) {
            const yes = res.isConfirmed;
            if (yes) {
              props.deleteUser(selectCheckDataGetId, "user");
            }
          }
        })
        .catch((err) => console.log(err));
    }

    setActionPagination("");
    setSelectCheckData([]);
    setSelectAllChecked(false);
  };

  const ManageUserData = [
    {
      Header: (
        <input
          type="checkbox"
          checked={selectAllChecked}
          onChange={handleSelectAll}
        />
      ),
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id,
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "ID",
      body: "id",
      Cell: ({ row }) => (
        <span className="text-capitalize    ">{row?.uniqueId}</span>
      ),
    },
    {
      Header: "USERNAME",
      body: "userName",
      Cell: ({ row, index }) => (
        <div
          className="d-flex align-items-center "
          style={{ cursor: "pointer" }}
          onClick={() => handleEdit(row, "manageUser")}
        >
          <img src={showURLs[index]} width="40px" height="40px" />
          <span className="text-capitalize    text-nowrap">
            {row?.nickName}
          </span>
        </div>
      ),
    },
    {
      Header: "EMAIL",
      body: "email",
      Cell: ({ row }) => (
        <span className="text-lowercase    ">{row?.email}</span>
      ),
    },
    // {
    //   Header: "IP ADDRESS",
    //   body: "callEndReason",
    //   class: " ",
    //   Cell: ({ row }) => <span>{row?.ipAddress}</span>,
    // },
    {
      Header: "STATUS",
      body: "status",
      Cell: ({ row }) => <span>{row?.isBlock ? "Block" : "Unblock"}</span>,
    },
    {
      Header: "Joined At",
      Cell: ({ row }) => dayjs(row?.createdAt).format("DD/MM/YYYY"),
    },
    {
      Header: "IS BLOCK",
      body: "isActive",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isBlock}
          onChange={() => handleIsActive(row)}
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch(
      getUser({
        type: "realUser",
        page,
        limit: size,
        startDate,
        endDate,
        searchText: debounceSearchText,
      }),
    );
  }, [dispatch, startDate, endDate, page, size, debounceSearchText]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleIsActive = (row) => {
    const id = row?._id;
    const data = row?.isBlock === false ? true : false;
    props.isActiveUser(id, "user", data);
  };

  const handleDeleteUser = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            props.deleteUser(id, "user");
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <div className="user-table real-user mb-3">
        <div className="user-table-top">
          <div className="mb-3">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "5px",
                marginTop: "5px",
              }}
            >
              User Table
            </h5>
          </div>
          <DataActions
            searchInputProps={{
              placeholder: "Search for ID, Name, Email",
              value: searchText,
              onValueChange: (value) => setSearchText(value),
            }}
            showActionOptions={true}
            dropdownProps={{
              value: actionPagination,
              options: [
                {
                  label: "Block",
                  value: "block",
                },
                {
                  label: "Unblock",
                  value: "unblock",
                },
              ],
              onChange: (value) => setActionPagination(value),
            }}
            actionButtonProps={{
              disabled: !actionPagination && !selectCheckData.length,
              onClick: paginationSubmitButton,
            }}
          />
        </div>

        <Table
          data={data}
          mapData={ManageUserData}
          noDataMessage="No User Found!"
        />

        <Pagination
          totalItem={totalUser}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </div>
  );
}
export default connect(null, {
  getUser,
  isActiveUser,
  deleteUser,
})(ManageUser);
